module.exports = __webpack_public_path__ + "img/icon.4ece8b27.png";